function buildPages(current, totalPages) {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(totalPages - 1, current + 1);

  if (start > 2) pages.push("ellipsis-start");
  for (let page = start; page <= end; page += 1) pages.push(page);
  if (end < totalPages - 1) pages.push("ellipsis-end");
  pages.push(totalPages);
  return pages;
}

export default function AdminPagination({
  offset,
  limit,
  total,
  itemLabel,
  visibleCount,
  disabled,
  onPage,
}) {
  const totalPages = Math.max(1, Math.ceil((total || 0) / limit));
  const currentPage = Math.min(totalPages, Math.floor((offset || 0) / limit) + 1);
  const pages = buildPages(currentPage, totalPages);
  const from = total === 0 ? 0 : offset + 1;
  const to = offset + visibleCount;

  return (
    <div className="admin-pagination">
      <span className="admin-pagination-info">
        {total} {itemLabel}
        {total === 1 ? "" : "s"} · mostrando {from}–{to}
      </span>
      <div className="admin-pagination-actions">
        {pages.map((page) =>
          typeof page === "string" ? (
            <span key={page} className="admin-page-ellipsis">
              …
            </span>
          ) : (
            <button
              key={page}
              type="button"
              className={`admin-page-btn${page === currentPage ? " admin-page-btn-active" : ""}`}
              disabled={disabled || page === currentPage}
              onClick={() => onPage((page - 1) * limit)}
            >
              {page}
            </button>
          )
        )}
      </div>
    </div>
  );
}
